export enum Env {
    LOCAL = "local",
    DEV = "dev",
    RECETTE = "recette",
    PROD = "prod",
    PREVIEW = "preview"
};
